import { render, staticRenderFns } from "./PieChartCustom.vue?vue&type=template&id=8cc8a00e&"
import script from "./PieChartCustom.vue?vue&type=script&lang=js&"
export * from "./PieChartCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports